import React, { useEffect, useState } from 'react';
import { AI_BUDGET_REQUIRED_EVENT } from '../services/aiBudgetStatus';

const formatCap = value => `$${Number(value || 10).toLocaleString('en-US', { maximumFractionDigits: 2 })}`;

export default function AiBudgetNotice() {
  const [notice, setNotice] = useState(null);

  useEffect(() => {
    const show = event => setNotice({ monthly_cap_usd: Number(event?.detail?.monthly_cap_usd) || 10 });
    window.addEventListener(AI_BUDGET_REQUIRED_EVENT, show);
    return () => window.removeEventListener(AI_BUDGET_REQUIRED_EVENT, show);
  }, []);

  if (!notice) return null;

  return (
    <div className="ai-budget-notice" role="status" aria-live="polite">
      <div className="ai-budget-notice-icon" aria-hidden="true">$</div>
      <div className="ai-budget-notice-copy">
        <strong>{formatCap(notice.monthly_cap_usd)} monthly AI budget reached</strong>
        <span>New AI generation is paused. Your saved Coach history and strategy remain available.</span>
      </div>
      <button type="button" onClick={() => setNotice(null)} aria-label="Dismiss AI budget notice">×</button>
    </div>
  );
}
